import { Box, Button, Heading } from '@chakra-ui/react'

export const ErrorMessage = ({
  errorMessage,
  reloadPage = false,
  reloadButtonText = 'Reload'
}: {
  errorMessage: string
  reloadPage: boolean
  reloadButtonText?: string
}): JSX.Element => {
  return (
    <Heading
      size={'md'}
      m="4"
      mt="8"
      color={'orange.500'}
      textAlign="center"
    >
      {errorMessage}
      {reloadPage && (
        <Box mt="4">
          <Button
            onClick={() => {
              window.location.reload()
            }}
            colorScheme={'gray'}
            variant="outline"
          >
            {reloadButtonText}
          </Button>
        </Box>
      )}
    </Heading>
  )
}
